

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import feeTable from './feeTable.vue'
import LawsuitApi from '@/api/lawsuit'
import { hasValue } from '@/utils/util'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'setLitigationPlan',
	components: {
		PageLayout,
		feeTable,
	},
})
export default class SetLitigationPlan extends Vue {
	private initialPlan: any = {}
	// 保存组件创建时的页面跳转参数
	private params: any = {}
	// private index: number = 0

	private handleSubmit(data: any) {
		if (this.params) {
			LawsuitApi.savePlanList({
				...data,
				orderId: this.params.orderId,
				schemeId: this.initialPlan.schemeId,
			}).then((res: any) => {
				this.$multiTab.closeCurrentPage()
				this.$multiTab.open(`/lawsuit/taskDetail/${this.params.orderId}`)
			})
		}
	}

	private handleCancel() {
		this.$multiTab.closeCurrentPage()
		if (this.params) {
			this.$multiTab.open(`/lawsuit/taskDetail/${this.params.orderId}`)
		}
	}

	private async initPlan() {
		this.params = this.$route.params
		let res: any = await LawsuitApi.getLawsuitTaskDetail(this.params.orderId)
		this.$set(
			this.params,
			'includeFormType',
			res.data.orderInfo.includeFormType
		)
		this.$set(this.params, 'death', res.data.orderInfo.death)
		if (this.params) {
			LawsuitApi.getPlanList(this.params.orderId).then((res: any) => {
				this.initialPlan = (res.data && res.data[0]) || {}
				// this.index = (res.data && res.data.length) || 0
			})
		}
	}

	private activated() {
		this.initPlan()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		// 相同动态路由之间切换
		this.$nextTick(() => {
			this.initPlan()
		})
		next()
	}
}
